import React from 'react';
import Plotly from 'plotly.js/lib/core';
import createPlotlyComponent from 'react-plotly.js/factory';
import InTEM_data from '../../data/intemTotalEmissions2012.json';
import Inventory_data from '../../data/inventoryTotalEmissions2012.json';
import RHIME_data from '../../data/rhimeTotalEmissions2018.json';
import CH4YearRHIME from '../../data/ch4_year_RHIME.json';
import CH4YearInTEM from '../../data/ch4_year_InTEM.json';
import IntemTotalEmissions from '../../data/intem_all_species.json';
import RhimeTotalEmissions from '../../data/rhime_all_species.json';
import InventoryTotalEmissions from '../../data/inventory_all_species.json';
// Below mentioned uncertainities are Currently used for total and combined dropdown selection model.
import IntemUncertainties from '../../data/intem_uncertainity.json'; 
import RhimeUncertainties from '../../data/rhime_uncertainilty.json';
import gemmaAllBrands from '../../images/logos/GEMMAplussubbrands.jpg'
import { chartColors } from '../../chartColors';

type NumberRecord = Record<string, number>;
type PlotTrace = {
  y: Array<number | null>;
  [key: string]: unknown;
};


;const Plot = createPlotlyComponent(Plotly);


const alignData = (intemData, rhimeData, inventoryData) => {
  console.log(InTEM_data)
  const allTimes = Array.from(
    new Set([...intemData.flatMap(item => item.time), ...inventoryData.flatMap(item => item.time), ...rhimeData.flatMap(item => item.time)])
  ).sort();

  const fillMissingValues = (data, allTimes) => {
    return data.map(item => {
      const emissionsMap = item.time.reduce((acc, time, index) => {
        acc[time] = { emission: item.emissions[index], std: item.emissions_std?.[index] || 0 };
        return acc;
      }, {});

      const filledEmissions = allTimes.map(time => emissionsMap[time]?.emission ?? null);
const filledEmissionsStd = allTimes.map(time => emissionsMap[time]?.std ?? null);

      console.log(filledEmissions)
      return { ...item, time: allTimes, emissions: filledEmissions, emissions_std: filledEmissionsStd };
    });
  };

  const filledIntemData = fillMissingValues(intemData, allTimes);
  const filledInventoryData = fillMissingValues(inventoryData, allTimes);
  const filledRhimeData = fillMissingValues(rhimeData, allTimes);
  console.log(filledIntemData)
  return { filledIntemData, filledInventoryData, filledRhimeData, allTimes };
};

// const calculateTotalEmissions = (data) => {
//   if (!data || data.length === 0 || !data[0].time) {
//     console.error('Data is not available or not properly structured');
//     return { totalEmissions: [], totalEmissionsStd: [] };
//   }

//   const totalEmissions = data[0].time.map((_, i) => (
//     data.reduce((acc, species) => acc + (species.emissions[i] || 0), 0)
//   ));

//   const totalEmissionsStd = data[0].time.map((_, i) => (
//     Math.sqrt(data.reduce((acc, species) => acc + ((species.emissions_std[i] || 0) ** 2), 0))
//   ));

//   return { totalEmissions, totalEmissionsStd };
// };

const filterZeroValues = (x, y, yStd) => {
  const filteredData = x.map((time, i) => ({
    time,
    emission: y[i],
    emissionStd: yStd ? yStd[i] : null,
  })).filter(dataPoint => dataPoint.emission !== null && dataPoint.emission !== 0);

  return {
    x: filteredData.map(dataPoint => dataPoint.time),
    y: filteredData.map(dataPoint => dataPoint.emission),
    yStd: yStd ? filteredData.map(dataPoint => dataPoint.emissionStd) : null,
  };
};

const MultiLinePlot = ({ selectedSpecies, selectedResolution }) => {
  if (!InTEM_data || !InTEM_data.length || !Inventory_data || !Inventory_data.length) {
    return <div>Data not available</div>;
  }
  let updatedInTEMData, updatedRHIMEData, updatedInventoryData;

if (selectedResolution === "yearly") {
  
    updatedInTEMData = CH4YearInTEM;
    updatedRHIMEData = CH4YearRHIME;
    updatedInventoryData = Inventory_data; // Or CH4YearInventory if available

} else {
  updatedInTEMData = InTEM_data;
  updatedRHIMEData = RHIME_data;
  updatedInventoryData = Inventory_data;
}

// console.log(updatedRHIMEData)
const {
  filledIntemData,
  filledInventoryData,
  filledRhimeData,
  allTimes,
} = alignData(updatedInTEMData, updatedRHIMEData, updatedInventoryData);

  // Define pastel colors for each model
  const modelColors: Record<string, string> = {
    InTEM: chartColors.InTEM,
    RHIME: chartColors.RHIME,
    'Inventory-2025': chartColors.Inventory,
  };

  const modelColorsLine: Record<string, string> = {
    InTEM: chartColors.InTEM,
    Inventory: chartColors.Inventory,
    RHIME: chartColors.RHIME,
  }
  const traces: PlotTrace[] = [];

  // Add baseline traces for models
  traces.push(
    {
      x: allTimes,
      y: [0.0],
      type: 'scatter',
      mode: 'lines',
      name: 'InTEM',
      line: { color: modelColors.InTEM, width: 2 },
      showlegend: false,
    },
    {
      x: allTimes,
      y: [0.0],
      type: 'scatter',
      mode: 'lines',
      name: 'Inventory-2025',
      line: { color: modelColors['Inventory-2025'], width: 2},
      showlegend: false,
    },
    {
      x: allTimes,
      y: [0.0],
      type: 'scatter',
      mode: 'lines',
      name: 'RHIME',
      line: { color: modelColors.RHIME, width: 2, dash: 'dashdot' },
      showlegend: false,
    },
  );

// Function to add uncertainty bounds around the emissions data
const calculateIntemUncertaintyBounds = (data: NumberRecord) => {
  const upperBounds = [];
  const lowerBounds = [];

  Object.entries(data).forEach(([year, emissions]) => {
    const uncertainty = (IntemUncertainties as NumberRecord)[year];
    if (uncertainty !== undefined) {
      upperBounds.push(emissions + uncertainty);
      lowerBounds.push(emissions - uncertainty);
    }
  });

  return { upperBounds, lowerBounds };
};
// Expands yearly (or discrete) data into duplicated step points for Plotly hv lines
function makeSteppedData(x, y) {
  const steppedX = [];
  const steppedY = [];

  for (let i = 0; i < x.length; i++) {
    const start = new Date(x[i]);
    const end = i < x.length - 1
      ? new Date(x[i + 1])
      : new Date(start.getFullYear() + 1, start.getMonth(), start.getDate());

    // Duplicating the values so horizontal hold, then jump
    steppedX.push(start, end);
    steppedY.push(y[i], y[i]);
  }

  return { x: steppedX, y: steppedY };
}

const calculateRhimeUncertaintyBounds = (data: NumberRecord) => {
  const upperBoundsRhime = [];
  const lowerBoundsRhime = [];

  Object.entries(data).forEach(([year, emissions]) => {
    const uncertainty = (RhimeUncertainties as NumberRecord)[year];
    if (uncertainty !== undefined) {
      upperBoundsRhime.push(emissions + uncertainty);
      lowerBoundsRhime.push(emissions - uncertainty);
    }
  });

  return { upperBoundsRhime, lowerBoundsRhime };
  };

  if (selectedSpecies === 'total') {
    //total emissions data
    const intemTotal = IntemTotalEmissions as NumberRecord; //total data for InTEM
    const inventoryTotal = InventoryTotalEmissions as NumberRecord; //total data for Inventory
    const rhimeTotal = RhimeTotalEmissions as NumberRecord; //total data for RHIME

    // Filter data to show only after 2012 for InTEM and RHIME
    const filterDataAfter2012 = (data: NumberRecord): NumberRecord => {
      return Object.fromEntries(
        Object.entries(data).filter(([year]) => parseInt(year) > 2012 && parseInt(year) <= 2023));
    };

    const filteredIntemTotal = filterDataAfter2012(intemTotal);
    const filteredRhimeTotal = filterDataAfter2012(rhimeTotal);
    const { upperBounds, lowerBounds } = calculateIntemUncertaintyBounds(filteredIntemTotal);
    const { upperBoundsRhime, lowerBoundsRhime } = calculateRhimeUncertaintyBounds(filteredRhimeTotal);
    
    traces.push(
      {
        x: Object.keys(inventoryTotal).map((date) => new Date(date)),
        y: Object.values(inventoryTotal),
        type: 'scatter',
        mode: 'lines',
        name: 'Inventory-2025',
        line: { color: modelColorsLine.Inventory, width: 2},
        legendgroup: 'inventorytotalemissions',
        showlegend: true,
      },
      {
        x: Object.keys(filteredIntemTotal).map((date) => new Date(date)),
        y: Object.values(filteredIntemTotal),
        type: 'scatter',
        mode: 'lines',
        name: 'InTEM Total Emissions',
        line: { color: modelColorsLine.InTEM, width: 2, dash: 'dashdot' },
        legendgroup: 'intemtotalemissions',
        showlegend: true,
      },
      {
        x: Object.keys(filteredIntemTotal).map((date) => new Date(date)),
        y: upperBounds,
        type: 'scatter',
        mode: 'lines',
        line: { color: modelColors.InTEM, width: 0.1, },
        fill: 'none',
        hoverinfo: 'skip',
        legendgroup: 'intemtotalemissions',
        showlegend: false,
      },
      {
        x: Object.keys(filteredIntemTotal).map((date) => new Date(date)),
        y: lowerBounds,
        type: 'scatter',
        mode: 'lines',
        line: { color: modelColors.InTEM, width: 0.1 },
        fill: 'tonexty',
        hoverinfo: 'skip',
        name: 'InTEM uncertainities',
        legendgroup: 'intemtotalemissions',
        showlegend: false,
      },
      {
        x: Object.keys(filteredRhimeTotal).map((date) => new Date(date)),
        y: Object.values(filteredRhimeTotal),
        type: 'scatter',
        mode: 'lines',
        name: 'RHIME Total Emissions',
        line: { color: modelColorsLine["RHIME"], width: 2, dash: 'dashdot'  },
        legendgroup: 'rhimetotalemissions',
        showlegend: true,
      },
      {
        x: Object.keys(filteredRhimeTotal).map((date) => new Date(date)),
        y: upperBoundsRhime,
        type: 'scatter',
        mode: 'lines',
        line: { color: modelColors.RHIME, width: 0.1 },
        fill: 'none',
        hoverinfo: 'skip',
        legendgroup: 'rhimetotalemissions',
        showlegend: false,
      },
      {
        x: Object.keys(filteredRhimeTotal).map((date) => new Date(date)),
        y: lowerBoundsRhime,
        type: 'scatter',
        mode: 'lines',
        line: { color: modelColors.RHIME, width: 0.1 },
        fill: 'tonexty',
        hoverinfo: 'skip',
        name: 'RHIME uncertainities',
        legendgroup: 'rhimetotalemissions',
        showlegend: false   ,
      }
    );
  } 
  else if (selectedSpecies === 'combined') {
    const intemTotal = IntemTotalEmissions as NumberRecord; //total data for InTEM
    const inventoryTotal = InventoryTotalEmissions as NumberRecord; //total data for Inventory
    const rhimeTotal = RhimeTotalEmissions as NumberRecord; //total data for RHIME

  // Filter data to show only after 2012 for InTEM and RHIME
  const filterDataAfter2012 = (data: NumberRecord): NumberRecord => {
    return Object.fromEntries(
      Object.entries(data).filter(([year]) => parseInt(year) >= 2012)
    );
  };

  const filteredIntemTotal = filterDataAfter2012(intemTotal);
  const filteredRhimeTotal = filterDataAfter2012(rhimeTotal);

  // Computing mean emissions and uncertainties
  const meanEmissions = Object.keys(filteredIntemTotal).map(year => {
    const intemValue = filteredIntemTotal[year] || 0;
    const rhimeValue = filteredRhimeTotal[year] || 0;

    return (intemValue + rhimeValue) / 2;
  });

  const { upperBounds } = calculateIntemUncertaintyBounds(filteredIntemTotal);
  const {  lowerBoundsRhime } = calculateRhimeUncertaintyBounds(filteredRhimeTotal);

  // Adding mean emissions and uncertainty as a new trace
  traces.push(
    {
      x: Object.keys(inventoryTotal).map((date) => new Date(date)),
      y: Object.values(inventoryTotal),
      type: 'scatter',
      mode: 'lines',
      name: 'Inventory Total Emissions',
      line: { color: modelColorsLine.Inventory, width: 2},
      legendgroup: 'inventorytotalemissions',
      showlegend: true,
    },
    {
      x: Object.keys(filteredIntemTotal).map(date => new Date(date)),
      y: meanEmissions,
      type: 'scatter',
      mode: 'lines',
      name: 'Mean Emissions (InTEM + RHIME)',
      line: { color: chartColors.Mean, width: 2, dash: 'solid' },
      legendgroup: 'IntemmeanEmissions',
      showlegend: true,
    },
    {
      x: Object.keys(filteredIntemTotal).map(date => new Date(date)),
      y: upperBounds,
      type: 'scatter',
      mode: 'lines',
      line: { color: chartColors.Mean, width: 0.1 },
      fill: 'none',
      hoverinfo: 'skip',
      legendgroup: 'meanUncertainty',
      showlegend: false,
    },
    {
      x: Object.keys(filteredIntemTotal).map(date => new Date(date)),
      y: lowerBoundsRhime,
      type: 'scatter',
      mode: 'lines',
      line: { color: chartColors.Mean, width: 0.1 },
      fill: 'tonexty',
      hoverinfo: 'skip',
      name: 'Mean Uncertainty',
      legendgroup: 'meanUncertainty',
      showlegend: true,
    }
  );
  }
  else {
  const filterSpeciesDataAfter2012 = (data) => {
    return data.map(item => {
      const filtered = item.time
        .map((year, i) => ({ year, emission: item.emissions[i], std: item.emissions_std[i] }))
        .filter(entry => parseInt(entry.year) > 2012);
        console.log(data)
  
      return {
        ...item,
        time: filtered.map(f => f.year),
        
        emissions: filtered.map(f => f.emission),
        emissions_std: filtered.map(f => f.std),
      };
    });
  };
 
  const addSpeciesTraces = (data, modelName, lineDash = 'solid') => {
    data.forEach((item) => {
      if (selectedSpecies === 'all' || selectedSpecies === item.species) {
        const errorMinus = item.emissions.map((value, i) => value - item.emissions_std[i]);
        const errorPlus = item.emissions.map((value, i) => value + item.emissions_std[i]);
  
        const filteredData = filterZeroValues(item.time, item.emissions, item.emissions_std);
        const filteredErrorMinus = filterZeroValues(item.time, errorMinus, null);
        const filteredErrorPlus = filterZeroValues(item.time, errorPlus, null);
  
        let plotX = filteredData.x;
        let plotY = filteredData.y;
        let plotFilteredErrorMinusX = filteredErrorMinus.x;
        let plotFilteredErrorMinusY = filteredErrorMinus.y;
        let plotFilteredErrorPlusX = filteredErrorPlus.x;
        let plotFilteredErrorPlusY = filteredErrorPlus.y;

        // Apply step expansion only for Inventory-2025
        if (modelName === 'Inventory-2025') {
          const stepped = makeSteppedData(filteredData.x, filteredData.y);
          plotX = stepped.x;
          plotY = stepped.y;
          const steppedErrorMinus = makeSteppedData(filteredErrorMinus.x,filteredErrorMinus.y)
          plotFilteredErrorMinusX = steppedErrorMinus.x;
          plotFilteredErrorMinusY = steppedErrorMinus.y;

          const steppedErrorPlus = makeSteppedData(filteredErrorPlus.x,filteredErrorPlus.y)

          plotFilteredErrorPlusX = steppedErrorPlus.x;
          plotFilteredErrorPlusY = steppedErrorPlus.y;
        }
  
        traces.push(
          // Lower bound
          {
            x: plotFilteredErrorMinusX,
            y: plotFilteredErrorMinusY,
            type: 'scatter',
            mode: 'lines',
            line: { color: modelColors[modelName], width: 0.1 },
            fill: 'none',
            hoverinfo: 'skip',
            showlegend: false,
            legendgroup: `main-${modelName}`,
          },
          // Upper bound (shaded area)
          {
            x: plotFilteredErrorPlusX,
            y: plotFilteredErrorPlusY,
            type: 'scatter',
            mode: 'lines',
            fill: 'tonexty',
            line: { color: modelColors[modelName], width: 0.1 },
            hoverinfo: 'skip',
            name: `Uncertainty - ${modelName}`,
            showlegend: modelName === 'Inventory-2025' ? false : true,
            legendgroup: `main-${modelName}`,
          },
          // Main Line
          {
            x: plotX,
            y: plotY,
            type: 'scatter',
            mode: 'lines',
            line: modelName === 'Inventory-2025'
              ? { color: modelColorsLine.Inventory, shape: 'hv' } // solid stepped line
              : { color: modelColorsLine[modelName], dash: 'dashdot' },
            name: `${modelName}`,
            hovertemplate: `${modelName} %{x|%Y}: %{y:.0f} (Mt) yr⁻¹<extra></extra>`,
            showlegend: true,
            legendgroup: `main-${modelName}`,
          },
        );
      }
    });
  };

  

    // Only apply filter if selected species is CH4
const isCH4 = selectedSpecies === 'CH4';

// Filter data after 2012 for CH4 species
const rhimeData = isCH4 ? filterSpeciesDataAfter2012(filledRhimeData) : filledRhimeData;
const intemData = isCH4 ? filterSpeciesDataAfter2012(filledIntemData) : filledIntemData;
const inventoryData = filledInventoryData;

if(selectedResolution === "yearly"){
  const filteredInTEMData = updatedInTEMData.filter(
    (entry) => entry.species === selectedSpecies
  );

  const filteredRHIMEData = updatedRHIMEData.filter(
    (entry) => entry.species === selectedSpecies
  );
  addSpeciesTraces(filteredInTEMData, 'InTEM');
  addSpeciesTraces(filteredRHIMEData, 'RHIME', 'dashdot');

  addSpeciesTraces(inventoryData, 'Inventory-2025', 'dash');
}
else{
// Then use these filtered datasets:
addSpeciesTraces(intemData, 'InTEM');
addSpeciesTraces(rhimeData, 'RHIME', 'dashdot');

addSpeciesTraces(inventoryData, 'Inventory-2025', 'dash');
}


  }
    if (traces.length === 0) {
      return <div>No data available for selected species</div>;
    }
    const layout = {
      images: [
        {
          source: gemmaAllBrands, // or base64 string
          xref: "paper",
      yref: "paper",
      x: 0.98,
      y: 1,
      sizex: 0.2, // adjust as needed
      sizey: 0.2, // adjust as needed
      xanchor: "right", // align the image's right edge with x=1
      yanchor: "top",   // align the image's top edge with y=1
          opacity: 0.6,
          layer: "below"
        }
      ],
    autosize: true,
    yaxis: {
      title: {
        text:
      selectedSpecies === 'CH4'
        ? 'CH<sub>4</sub> CO<sub>2</sub> equivalent (Mt)'
        : selectedSpecies === 'N2O'
        ? 'N<sub>2</sub>O CO<sub>2</sub> equivalent (Mt)'
        : selectedSpecies === 'HFCs'
        ? 'HFCs CO<sub>2</sub> equivalent (Mt)'
        : selectedSpecies === 'PFCs'
        ? 'PFCs CO<sub>2</sub> equivalent (Mt)'
        : 'CO<sub>2</sub> equivalent (Mt)'
        
        
  },
    range: selectedSpecies === 'CH4' ? [0, 100] : undefined,
    automargin: true,},
    legend: {
      traceorder: selectedSpecies !== 'total' ? 'reversed' : 'normal',
    },
    paper_bgcolor: '#FFFFFF',
    plot_bgcolor: '#FFFFFF',
    xaxis: {
      rangeselector: {
        buttons: [
          { count: 5, label: '5Y', step: 'year', stepmode: 'backward' },
          { count: 10, label: '10Y', step: 'year', stepmode: 'backward' },
          { step: 'all', label: 'All' },
        ],
      },
      rangeslider: { visible: false },
      type: 'date',
      range: ['2014-01-01', allTimes[allTimes.length - 1]],     
    },
  };  

  const tracesWithDividedValues = traces.map((trace) => ({
    ...trace,
    y: trace.y.map((value) => (value === null ? null : value / 1000)),
  }));

  return (
    <div>
      {['SF6',].includes(selectedSpecies.trim()) ? (
    <div
      style={{
        height: '400px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.5rem',
        color: '#526777',
        backgroundColor: '#EAF0F2',
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
      }}
    >
      Coming Soon: {selectedSpecies.trim()} Yearly Data
    </div>
      ) : (
        <div>
          <Plot
            data={tracesWithDividedValues}
            layout={layout}
            useResizeHandler
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      )}
    </div>
  );}

export default MultiLinePlot;
